<script setup>
import {onMounted, ref, watch} from "vue";
import dashboardService from "@/services/ecosystem/dashboard.service";
import {useRoute} from "vue2-helpers/vue-router";

const emit = defineEmits(['completed'])
const route = useRoute();

const step = ref(1);
const show = ref(false);
const alwaysShow = route.query.onboarding;

watch(step, value => {
    if (value > 3) {
        show.value = false;
        emit('completed');
    }

    if (!alwaysShow) {
        saveStep();
    }
});

onMounted(() => {
    if (alwaysShow) {
        show.value = true;
    } else {
        getLastStep();
    }
});

async function getLastStep() {
    const {data} = await dashboardService.getOnboardingStep();
    step.value = (data && data > 0) ? data : 1;

    if (step.value <= 3) {
        show.value = true;
    }
}

async function saveStep() {
    await dashboardService.saveOnboardingStep(step.value);
}
</script>

<template>
    <div
        v-if="show"
        id="needs-onboarding"
        class="needs-onboarding"
    >
        <div class="needs-onboarding__inner">
            <div v-if="step === 1">
                <h2 class="heading2">Welcome to SwitchPitch</h2>

                <ul class="needs-onboarding__list">
                    <li>Log needs and get AI & ecosystem recommendations</li>
                    <li>Manage your own needs or review submissions from your team</li>
                    <li>Perform diligence on solutions and convert to projects</li>
                </ul>
            </div>

            <div v-else-if="step === 2" class="pb-5">
                <h2 class="heading2">Needs</h2>
                <p>Your users can create needs and escalate them to you for review. Needs capture business challenges and use AI & VC network partners to suggest startup solutions.</p>
                <p>You can also create needs yourself.</p>
            </div>

            <div v-else-if="step === 3" class="pb-5">
                <h2 class="heading2">Projects</h2>
                <p class="mb-5">Once you’ve assessed a need, convert it into a project to perform diligence on the suggested startups and progress them through a funnel.</p>
            </div>

            <div class="btn-xl-wrapper">
                <a v-if="step > 1" @click="step--" class="btn btn-xl btn-xl-back"></a>

                <a @click="step++" class="btn btn-xl btn-xl-next">
                    <template v-if="step === 3">
                        Get Started
                    </template>

                    <template v-else>
                        Next
                    </template>
                </a>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>
